// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 4.38574H20V15.9004L19.5811 16.1992L12 21.6143L4.41895 16.1992L4 15.9004V4.38574H2V2.38574H22V4.38574ZM9 13.3857H15V11.3857H9V13.3857ZM8 9.38574H16V7.38574H8V9.38574Z"}}]};

const ContributeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'contribute-filled',
    ref,
    icon: element,
  },
));

ContributeFilledIcon.displayName = 'ContributeFilledIcon';

export default ContributeFilledIcon;
